import { Avatar, Link, Stack, Typography } from '@mui/material';
import { CustomMetaTitle } from 'Components';
import { mokedNumber } from 'Config';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ErrorScreen } from 'Images';

export const Error = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Error);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      m={isDesktop ? '75px 0 70px' : '40px 0 80px'}
      gap={isDesktop ? '20px' : '12px'}
    >
      <CustomMetaTitle title={dictionary.error} />
      <Typography variant={'h2'} color={'text.secondary'} component='h1'>
        {dictionary.title}
      </Typography>
      <Stack
        alignItems='center'
        justifyContent='center'
        direction={isDesktop ? 'row' : 'column'}
        textAlign={'center'}
        gap='6px'
      >
        <Stack>
          <Typography variant={'body2'}>{dictionary.subtitle[0]}</Typography>
          <Typography variant={'body2'}>{dictionary.subtitle[1]}</Typography>
        </Stack>
      </Stack>
      <Avatar
        src={ErrorScreen}
        alt=''
        sx={{
          width: isDesktop ? '550px' : '300px',
          height: isDesktop ? '382px' : '208px',
          m: '35px 0 26px',
        }}
      />
      <Stack
        alignItems='baseline'
        justifyContent='center'
        direction='row'
        gap='6px'
      >
        <Typography variant={'body3'}>{dictionary.contactUsText}</Typography>
        <Link underline={'hover'} href={`tel:${mokedNumber}`}>
          <Typography variant={'body3'} color={'primary.main'}>
            {dictionary.manualSupplyPhone}
          </Typography>
        </Link>
      </Stack>
    </Stack>
  );
};
